import "core-js/modules/es.array.concat.js";
import { each } from 'lodash';
import raiseErrorMessage from "./raiseErrorMessage";
var showErrors = function showErrors(error) {
  if (error && error.response && error.response.data && error.response.data.errors) {
    each(error.response.data.errors, function (msg, key) {
      return raiseErrorMessage(key == null ? error : "".concat(key, ": ").concat(msg));
    });
  } else if (error && error.errors) {
    each(error.errors, function (msg, key) {
      return raiseErrorMessage(key == null ? error : "".concat(key, ": ").concat(msg));
    });
  } else if (error && error.message) {
    raiseErrorMessage(error.message);
  } else {
    raiseErrorMessage(error);
  }
};
export default showErrors;